import { render } from "./header.vue?vue&type=template&id=23e07258"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=23e07258&lang=css"

import exportComponent from "F:\\workspace\\pros\\ydxc-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__